import React, { useRef, useState } from 'react'
import { Popover } from 'react-tiny-popover'
import { BubbleIcon, LikeIcon, RecycleIcon } from '../../../assets/icons'
import AudioPlayer from '../../../components/AudioPlayer.jsx/AudioPlayer'
import CreateReplyComment from '../../../components/Comments/CreateReplyComment'
import ButtonIcon from '../../../utils/components/ButtonIcon/ButtonIcon'
import ImageNameDescription from '../../../utils/components/ImageNameDescription/ImageNameDescription'
import Options from '../../../utils/components/Options/Options'
import localStorage from '../../../utils/hooks/useLocalStorage'
import useModal from '../../../utils/hooks/useModal'
import { parserNumberBase1000 } from '../../../utils/parsers/number'
import ModalReportPost from '../../ReportContent/ModalReportPost'
import './Comment.css'

const Comment = ({
    idCommentator,
    noAdd,
    setIsShowReport,
    setCommentToReport,
    reactions,
    communityID,
    setshowReplyComents = () => { },
    showReplyComents,
    createReactionBubble = () => { },
    createReactionRecycle = () => { },
    isReplyComment,
    secondName,
    type,
    commentId,
    firstName,
    srcImage,
    image,
    audio,
    video,
    comment,
    responses
}) => {
    //const [refRules, isShowReport, setIsShowReport] = useModal(false)
    const refOptContend = useRef(null)
    const [refOptions, isShowOptions, setIsShowOptions] = useModal(false);
    return (
        <div className={`comment-global-comment ${isReplyComment ? 'reply' : ''} ${showReplyComents === commentId ? 'show-reply' : ''}`}>

            <div className="content-comment-card">

            </div>
            <div className="content-comment">
                <div className='column'>
                    <ImageNameDescription
                        secondName={secondName ? secondName : ""}
                        firstName={firstName}
                        description={type}
                        srcImage={srcImage}
                        type={'header-message'}
                    />
                    <div className='column' style={{
                        position: "relative",
                        marginLeft: "auto"
                    }}>
                        {
                            localStorage().getItem("typeProfile") != "warehouse" && (//TodoEcoCeoSocial
                                <div className="hover-like-options-post" onMouseLeave={() => setIsShowOptions(!isShowOptions)} onMouseEnter={() => setIsShowOptions(true)}>
                                    <Popover
                                        containerStyle={
                                            {
                                                zIndex: 3000
                                            }
                                        }
                                        onClickOutside={() => setIsShowOptions(false)}
                                        isOpen={isShowOptions}
                                        reposition={true}
                                        positions={[]} // preferred positions by priority
                                        content={({ position, childRect, popoverRect }) => (


                                            <div ref={refOptContend} className="options-component">
                                                <div className="column">
                                                    <ButtonIcon
                                                        onClick={() => { createReactionBubble() }}
                                                        Icon={BubbleIcon}
                                                        text={parserNumberBase1000(reactions.bubbleLikes)}
                                                        type={"post-icon"}
                                                    />
                                                    <ButtonIcon
                                                        onClick={() => { createReactionRecycle() }}
                                                        Icon={RecycleIcon}
                                                        text={parserNumberBase1000(reactions.recyclingLikes)}
                                                        type={"post-icon"}
                                                    />
                                                </div>
                                            </div>

                                        )}

                                    >
                                        <div  onMouseEnter={() => setIsShowOptions(true)}>
                                        <ButtonIcon  widthIcon='12' Icon={LikeIcon} text={parserNumberBase1000(reactions.total)} type={"post-icon"} />
                                        </div>
                                       
                                    </Popover>




                                   
                                </div>
                            )
                        }
                     
                        <Options
                            style={{
                                position: "relative",
                                marginLeft: "auto"
                            }}
                            options={[
                                localStorage().getItem("idProfile") !== idCommentator &&  {
                                    text: "Reportar",
                                    onClick: (e) => {
                                        setCommentToReport(commentId)
                                        setIsShowReport(true)

                                    }
                                }
                            ].filter(opt => typeof opt != "boolean")}
                        />

                    </div>
                </div>
                <div>
                    <div className='pl-4 pl-4'>
                        {comment}
                    </div>
                    {
                        image && <img className='img-post-view' src={image.url.origin} alt="" />

                    }
                    {
                        audio && <AudioPlayer url={audio.url.origin} />
                    }
                    {
                        video && <video preload="auto" className="video-post-view" controls>
                            <source src={video.url.origin}></source>
                        </video>
                    }
                </div>


            </div>
            {responses > 0 && <div>{responses==1 ? `${responses} respuesta`:` ${responses} respuestas`} </div>}
            {!isReplyComment && showReplyComents !== commentId &&
                <div onClick={() => { setshowReplyComents(commentId) }} className="content-response-comment">
                    responder
                </div>}
            {showReplyComents === commentId &&
                <div className="content-coments-reply">

                    <CreateReplyComment isProfessional={false} isMark={false} commentID={commentId} />
                </div>
            }
        </div>
    )
}

export default Comment
